export default {
    GET_AMENITIES_LIST_LOADING: 'GET_AMENITIES_LIST_LOADING',
    GET_AMENITIES_LIST_SUCCESS: 'GET_AMENITIES_LIST_SUCCESS',
    GET_AMENITIES_LIST_FAILED: 'GET_AMENITIES_LIST_FAILED',
    GET_AMENITIES_LIST_REJECT: 'GET_AMENITIES_LIST_REJECT',
  };